const BYTE_UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

// 1024 기준으로 바이트를 사람이 읽기 쉬운 단위로 바꾼다. 100 이상은 정수로, 100 미만은
// 소수 1자리로 표시해 목록 폭을 좁게 유지한다. null·undefined·비유한값은 빈칸 토큰(empty,
// 기본 "-")으로 표시한다. em대시("—")를 쓰는 화면은 그 토큰을 전달한다. 로케일 compact 표기를
// 쓰지 않으므로 "6억byte" 같은 그룹핑 버그가 생기지 않는다.
export function formatBytes(bytes: number | null | undefined, empty = "-"): string {
  if (bytes == null || !Number.isFinite(bytes)) {
    return empty;
  }
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < BYTE_UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  const formatted = value >= 100 ? value.toFixed(0) : value.toFixed(1);
  return `${formatted} ${BYTE_UNITS[unitIndex]}`;
}
